
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherAllocateGrid extends Serenity.EntityGrid<GiftVoucherAllocateRow, any> {
        protected getColumnsKey() { return 'Retail.GiftVoucherAllocate'; }
        protected getDialogType() { return GiftVoucherAllocateDialog; }
        protected getIdProperty() { return GiftVoucherAllocateRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherAllocateRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherAllocateRow.localTextPrefix; }
        protected getService() { return GiftVoucherAllocateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(64);
            this.editItem(<GiftVoucherAllocateRow>{
                VoucherNo: voucherNo,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                UserId: Q.Authorization.userDefinition.UserId,
                VoucherTypeId: 64,
                TransDate: now.toDateString()

            });
        }
    }
}